import { useCallback } from 'react';
import { useQueries } from 'react-query';
import { SchemaFeatureFlags } from '@frontend/schema';
import { useOrgData } from './use-org-data';

export const useOrgFeatureFlags = () => {
  const { locationIdsWithoutParent } = useOrgData();

  const ffQueries = useQueries(
    locationIdsWithoutParent.map((locationId) => {
      return {
        queryKey: [locationId, 'features'],
        queryFn: () => {
          return SchemaFeatureFlags.ListLocationFlags(
            { locationId: locationId },
            { headers: { 'Location-Id': locationId } }
          );
        },
      };
    })
  );

  const getFeatureFlagAllEnabled = useCallback(
    (flagName: string) => {
      // race condition: there can be no locations yet (i.e. [])
      if (!ffQueries.length) return false;
      // all locations must have the flag enabled
      return ffQueries.every((q) => q.data?.flags?.find(({ flag }) => flag?.name === flagName)?.value);
    },
    [ffQueries]
  );

  const getFeatureFlagAnyEnabled = useCallback(
    (flagName: string) => {
      // race condition: there can be no locations yet (i.e. [])
      if (!ffQueries.length) return false;
      // at least one location must have the flag enabled
      return ffQueries.some((q) => q.data?.flags?.find(({ flag }) => flag?.name === flagName)?.value);
    },
    [ffQueries]
  );

  return { getFeatureFlagAllEnabled, getFeatureFlagAnyEnabled };
};
